<template>
  <div class="customer-support">
    <h1 class="page-title title">{{ $t('customer.support.label.1') }}</h1>
    <div class="page-ct">
      <div class="section">

        <h4 class="title box-title">
          <span>{{ $t('customer.support.label.20') }}</span>
        </h4>
        <div class="page-meta">
          <div class="row">
            <div class="col-sm-12">
              <p>{{ $t('customer.support.label.21') }}</p>
              <p>
                <a :href="this.supportFAQUrl"
                   target="_blank"
                   class="mw-200px btn-lg show-popup-help btn-customer-support">{{ $t('customer.support.label.22') }}</a>
              </p>
            </div>
          </div>
        </div>

        <hr class="border-light">
        <h4 class="title box-title">
          <span>{{ $t('customer.support.label.2') }}</span>
        </h4>
        <div class="box-ct">
          <div class="section-inner">
            <h5 class="title no-border">{{ $t('customer.support.label.3') }}</h5>
            <div class="download-btn-list">
              <div class="row">
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'pdf/manual_mypage.pdf'"
                     target="_blank"> <i class="far fa-file-pdf"></i>
                    {{ $t('customer.support.label.4') }}
                  </a>
                </div>
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'pdf/manual_systemtrader.pdf'"
                     target="_blank"> <i class="far fa-file-pdf"></i>
                    {{ $t('customer.support.label.5') }}
                    <small>{{ $t('customer.support.label.6') }}</small>
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'pdf/manual_fxtrader.pdf'"
                     target="_blank"> <i class="far fa-file-pdf"></i>
                    {{ $t('customer.support.label.7') }}
                    <small>{{ $t('customer.support.label.8') }}</small>
                  </a>
                </div>
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'pdf/manual_webtrader.pdf'"
                     target="_blank"> <i class="far fa-file-pdf"></i>
                    {{ $t('customer.support.label.9') }}
                    <small>{{ $t('customer.support.label.10') }}</small>
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'pdf/manual_optiontrader.pdf'"
                     target="_blank"> <i class="far fa-file-pdf"></i>
                    {{ $t('customer.support.label.11') }}
                    <small>{{ $t('customer.support.label.12') }}</small>
                  </a>
                </div>
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'pdf/manual_cointrader.pdf'"
                     target="_blank"> <i class="far fa-file-pdf"></i>
                    {{ $t('customer.support.label.30') }}
                    <small>{{ $t('customer.support.label.31') }}</small>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <hr class="border-light">
          <div class="section-inner">
            <h5 class="box-content-title">{{ $t('customer.support.label.29') }}</h5>
            <div class="download-btn-list">
              <div class="row">
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'pdf/manual_optiontrader_web.pdf'" target="_blank">
                    <i class="fa fa-file"></i> {{ $t('customer.support.label.18') }}
                    <small>{{ $t('customer.support.label.19') }}</small>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <hr class="border-light">
          <div class="section-inner">
            <h5 class="box-content-title">{{ $t('customer.support.label.13') }}</h5>
            <div class="download-btn-list">
              <div class="row">
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'manual/fxtrade_app_new/'" target="_blank">
                    <i class="fa fa-file"></i> {{ $t('customer.support.label.14') }}
                    <small>{{ $t('customer.support.label.15') }}</small>
                  </a>
                </div>
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'manual/sttrade_app/'" target="_blank">
                    <i class="fa fa-file"></i> {{ $t('customer.support.label.16') }}
                    <small>{{ $t('customer.support.label.17') }}</small>
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <a class="btn btn-download btn-block btn-border"
                     :href="this.minStHome+'manual/cointrade_app/'" target="_blank">
                    <i class="fa fa-file"></i> {{ $t('customer.support.label.30') }}
                    <small>{{ $t('customer.support.label.31') }}</small>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr class="border-light">
        <h4 class="title box-title">
          <span>{{ $t('customer.support.label.23') }}</span>
        </h4>
        <div class="page-meta">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="title no-border">{{ $t('customer.support.label.24') }}</h5>
              <p>
                <a :href="this.minStHome+'support/form/'"
                   target="_blank"
                   class="mw-200px btn btn-success btn-lg">{{ $t('customer.support.label.25') }}</a>
              </p>
            </div>
            <div class="col-sm-6">
              <h5 class="title no-border">{{ $t('customer.support.label.26') }}</h5>
              <h2 class="title no-border">
                TEL: <a :href="'tel:'+ this.telephone">{{ this.telephone }}</a>
              </h2>
              <p style="word-break: break-all; white-space: break-spaces;">
                {{ $t('customer.support.label.27') }}{{ this.headerInfo.telephoneReceptionHours }}
                <br>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import {SET_ACTIVE_TAB_ID, MENU_HOME} from '@/store/modules/header/type';
import postDocTemplateMixin from "@/common/mixins/postDocTemplate";

const {mapState: mapHeaderState} = createNamespacedHelpers("header");
/**
 * @author HungNS
 */

const {mapActions: mapHeaderAction} = createNamespacedHelpers('header');
export default {
  mixins: [postDocTemplateMixin],
  data: function () {
    return {
      minStHome: this.IConstants.WEB_LINK.MIN_ST_HOME,
      supportFAQUrl: this.IConstants.WEB_LINK.SUPPORT_FAQ_URL,
    };
  },
  computed: {
    ...mapHeaderState({
      headerInfo: state => state.headerInfo,
    }),
  },

  methods: {
    ...mapHeaderAction([SET_ACTIVE_TAB_ID]),
  },
  created() {
    this[SET_ACTIVE_TAB_ID](MENU_HOME);
  },
};
</script>

<style scoped>
.mw-200px {
  min-width: 200px !important;
}

.show-popup-help {
  display: inline-block;
  background-color: #ff9900;
  border: 3px solid #ff9900;
  padding: 7px;
  color: #ffffff;
}

.show-popup-help:hover {
  background-color: #ffffff;
  border: 3px solid #ff9900;
  color: #ff9900;
}

.btn-customer-support:hover {
  box-shadow: none!important;
}

.btn-customer-support {
  text-align: center;
}
</style>
